import { render, staticRenderFns } from "./BillsTime.vue?vue&type=template&id=f2ad85ca&scoped=true&"
import script from "./BillsTime.vue?vue&type=script&lang=js&"
export * from "./BillsTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ad85ca",
  null
  
)

export default component.exports